import { pctFmt } from '../shared/formatters'
import { fmtBrl, fmtInt, fmtMultiplier } from '../shared/formatters'
import { sum, avg } from '../shared/math'

const weightedAvg = (field, entries) => {
  let weightedSum = 0, weightTotal = 0;
  for (const e of entries) {
    const value = e[field];
    const weight = e.unitsSold;
    if (value != null && weight != null) {
      weightedSum += value * weight;
      weightTotal += weight;
    }
  }
  return weightTotal > 0 ? weightedSum / weightTotal : null;
};

export const calculateAggregateMetrics = ({ data, monthKeys, additionalFields = [] }) => {
  return monthKeys.map(key => {
    const [year, month] = key.split('-');
    const entries = data.filter(
      d => d.year === Number(year) && d.month === Number(month)
    );

    const grossRevenue = sum('grossRevenue', entries);
    const grossProfit = sum('grossProfit', entries);
    const unitsSold = sum('unitsSold', entries);

    const originalPrice = weightedAvg('originalPrice', entries);
    const salePrice = weightedAvg('salePrice', entries);
    const unitCostAvg = weightedAvg('unitCost', entries);
    const initialMarkupAvg = avg('initialMarkup', entries);
    const finalMarkupAvg = avg('finalMarkup', entries);

    const markdownPercent = (originalPrice != null && salePrice != null && originalPrice !== 0)
      ? (salePrice - originalPrice) / salePrice * 100
      : null;

    const markdownToShow = (markdownPercent != null && markdownPercent < 0)
      ? markdownPercent
      : null;

    const grossMarginRatio = (grossRevenue != null && grossProfit != null && grossRevenue !== 0)
      ? grossProfit / grossRevenue
      : null;

    const result = {
      _grossRevenue: grossRevenue,
      _grossProfit: grossProfit,
      _unitsSold: unitsSold,
      _unitCost: unitCostAvg,
      _originalPrice: originalPrice,
      _salePrice: salePrice,
      _initialMarkup: initialMarkupAvg,
      _finalMarkup: finalMarkupAvg,
      grossRevenue: fmtBrl(grossRevenue),
      unitsSold: fmtInt(unitsSold),
      originalPrice: fmtBrl(originalPrice),
      salePrice: fmtBrl(salePrice),
      markdownPercent: markdownToShow != null ? pctFmt.format(Math.abs(markdownToShow) / 100) : null,
      unitCost: fmtBrl(unitCostAvg),
      initialMarkup: fmtMultiplier(initialMarkupAvg),
      finalMarkup: fmtMultiplier(finalMarkupAvg),
      grossProfit: fmtBrl(grossProfit),
      grossMargin: grossMarginRatio != null ? pctFmt.format(grossMarginRatio) : null,
      _grossMargin: grossMarginRatio,
    };

    additionalFields.forEach(({ field, format }) => {
      const value = avg(field, entries);
      result[field] = value != null ? format(value) : null;
    });

    return result;
  });
};